export default __webpack_public_path__ + "static/media/Tucuman_Laprida.e71603a1.jpg";